export default (function (siteVars) {
  return {
    width: 300,
    height: 300,
    paddlePreviousSize: 32,
    paddleNextSize: 32,
    focusOuterBorderColor: siteVars.focusOuterBorderColor,
    focusOuterBorderRadius: siteVars.borderRadius
  };
});